var e;
((l) => {
  ((d) => {
    d[d.AdminOnly = 0] = "AdminOnly", d[d.Availability = 1] = "Availability", d[d.Booking = 2] = "Booking", d[d.Locked = 3] = "Locked", d[d.BookingAllowTeachers = 4] = "BookingAllowTeachers";
  })(l.GroupStatusEnum || (l.GroupStatusEnum = {})), ((d) => {
    d[d.TeacherAndStudent = 0] = "TeacherAndStudent", d[d.ClassAndStudent = 1] = "ClassAndStudent", d[d.ClassAndParent = 2] = "ClassAndParent";
  })(l.GroupConstraintsEnum || (l.GroupConstraintsEnum = {}));
})(e || (e = {}));
export {
  e as interviews
};
//# sourceMappingURL=index.js.map
